import React from 'react';

import { ErrorMessage } from '@eika/attention-message';
import { LinkButton } from '@eika/button';
import { InfoCard } from '@eika/card';
import { IconTypes } from '@eika/icon';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useCreditCardReservationsByAccount, useCreditCardTransactionsByAccount } from '@/domain/account';
import useText from '@/hooks/use-text';

import LoaderWithText from '@components/loading/LoaderWithText';

const Content = () => {
    const text = useText();

    const transactionsQuery = useCreditCardTransactionsByAccount();
    const reservationsQuery = useCreditCardReservationsByAccount();

    if (transactionsQuery.isFetchingNextPage) {
        return <LoaderWithText title={text.loadingMoreTransactions} />;
    }

    if (!transactionsQuery.hasNextPage) {
        return (
            <InfoCard skipBackground>
                <RichIcon type={RichIconTypes.LANDSKAP} />
                <InfoCard.TitleH3>{text.transactionNoMoreText}</InfoCard.TitleH3>
            </InfoCard>
        );
    }

    if (transactionsQuery.isError) {
        return <ErrorMessage text={text.transactionsFetchErrorMessage} icon={IconTypes.LUKK_24} />;
    }

    const reservationsListEmpty = reservationsQuery.data?.length === 0;
    const transactionListEmpty = transactionsQuery.data?.pages.flatMap((item) => item.elements).length === 0;

    if (!transactionsQuery.hasNextPage && transactionListEmpty && reservationsListEmpty) {
        return (
            <InfoCard skipBackground>
                <RichIcon type={RichIconTypes.PARK_M_FUGL} />
                <InfoCard.TitleH1>{text.transactionEmptyText}</InfoCard.TitleH1>
            </InfoCard>
        );
    }

    if (transactionsQuery.hasNextPage) {
        return (
            <LinkButton icon={IconTypes.PIL_NED} iconOnRightSide onClick={() => transactionsQuery.fetchNextPage()}>
                {text.transactionSeeMore}
            </LinkButton>
        );
    }

    return null;
};

export const Status = () => (
    <div className="transaction-list-with-status__status">
        <Content />
    </div>
);
